import { h, VNode, FunctionComponent, toChildArray } from "preact"; /** @jsx h */


import { Promoted, IPromotedProps } from './Promoted';
import { Item, IItemProps } from './Item';
import { Compact, ICompactProps } from "./Compact";
import { Standard, IStandardProps } from "./Standard";
import { Ordered, IOrderedProps } from "./Ordered";

export type IList = {
    Promoted: FunctionComponent<IPromotedProps>;
    Item: FunctionComponent<IItemProps>;
	Compact: FunctionComponent<ICompactProps>;
    Standard: FunctionComponent<IStandardProps>;
    Ordered: FunctionComponent<IOrderedProps>;
}

export const List: IList = {
    Promoted,
    Item,
    Compact,
    Standard,
    Ordered
};






